import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor() {}

  setToken(token: string): void {
    localStorage.setItem('token', token);
  }

  getToken(): string {
    return localStorage.getItem('token') ?? '';
  }

  isAuthenticated(): boolean {
    return !!localStorage.getItem('token');
  }

  getuserid() {
    const authdata = localStorage.getItem('authuser');
    if (!authdata) {
      return '';
    }
    const authdatajson = JSON.parse(authdata);
    return authdatajson['id'] ?? '';
  }

  clearToken(): void {
    localStorage.removeItem('token');
  }

  getemail() {
    const authdata = localStorage.getItem('authuser');
    if (!authdata) {
      return '';
    }
    const authdatajson = JSON.parse(authdata!);
    return authdatajson['email'];
  }
}
